import { render, staticRenderFns } from "./DocumentValidationSettings.vue?vue&type=template&id=23618fd8&"
import script from "./DocumentValidationSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentValidationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports